import React, { useState } from 'react';
import GroupField from '../GroupField';
import SpinnerBtn from '../../../../components/SpinnerBtn';

export default function EditField({ type, name, value, title, disable = true, handleChange, setFields, handleSubmit, multifield = false, user = {} , enableAddUrlAndEnvBtn, setEnableAddUrlAndEnvBtn}) {
    const [edit, setEdit] = useState(false);
    const [enableUrlAndEnv, setEnableUrlAndEnv] = useState(false);
    const [spinnerBtn, setSpinnerBtn] = useState(false);
    const [temp, setTemp] = useState({})
    const handleClick = async() => {
        setEdit(!edit);
        setSpinnerBtn(true);
        if (edit && !multifield) {
            await handleSubmit({ type: 'individual', name, value })
            setSpinnerBtn(true);
        }
        if (edit && multifield) {
            let finalResult = {
                ...user,
                baseURL: [...user.baseURL, temp.baseURL],
                environment: [...user.environment, temp.environment],
                listOfUrlAndEnv: [...user.listOfUrlAndEnv, {baseURL:temp.baseURL.value, environment: temp.environment.value}]
              }
            setFields(finalResult);
              await handleSubmit({ type: 'all', data: finalResult});
              setSpinnerBtn(true);
        }
        setSpinnerBtn(false);
    }
    const MultiTextField = () =>{
        return  <div className=' inline-flex gap-4'>
        <input
            type={type}
            name={"baseURL"}
            className="block rounded-md border-0 bg-white px-1 shad!multifield ?ow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
            placeholder='Enter url '
            required
            onChange={(e) => {
                const {name, value} = e.target;
                setTemp((prev) => ({...prev,  [name]:{'label': value, 'value': value}}));
            }}
        />
        <input
            type={type}
            name={"environment"}
            className="block rounded-md border-0 bg-white px-1 shad!multifield ?ow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
            placeholder='Enter Environment'
            required
            onChange={(e) => {
                const {name, value} = e.target;
                setTemp((prev) => ({...prev,  [name]:{'label': value, 'value': value}}));
            }}
        />
        </div>
    }

    const groupedFields = () =>{
        return <div className=' inline-flex gap-4'>
        <GroupField fields={user} handleDomainUrlChanges={(value, name) => { setEnableAddUrlAndEnvBtn && setEnableAddUrlAndEnvBtn(true); handleChange(null, name, value)}} targetField={"baseURL"} targetValue={'defaultURL'} />
        <GroupField fields={user} handleDomainUrlChanges={(value, name) => { setEnableAddUrlAndEnvBtn && setEnableAddUrlAndEnvBtn(true); handleChange(null, name, value)}} targetField={"environment"} targetValue={'defaultEnv'} />
    </div>
    }

    const saveDefaultUrlAndEnv = async() =>{
        setSpinnerBtn(true); 
        setEnableAddUrlAndEnvBtn(false);
        handleSubmit({ type: 'all', data: user});
        setSpinnerBtn(false);
    }
    return (
        <>
            <div className="pt-6 sm:flex">
                <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">{title}</dt>
                <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
                    {!edit ? !multifield ? (<div className="text-gray-900">{value}</div>) : (groupedFields()) : !multifield ? (<input
                        type={type}
                        name={name}
                        value={value}
                        className="block rounded-md border-0 bg-white/5 px-1 shad!multifield ?ow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
                        onChange={(e) => handleChange(e, null, null)}
                    />): MultiTextField()}
                   <div className=' inline-flex gap-4'>
                   {disable && <>
                   {!spinnerBtn ? <button onClick={handleClick} type="button" className="rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                        {!edit ? !multifield ? "Edit": "Add" : "Save"}
                    </button> : <SpinnerBtn style={"rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"}/>}
                   </> 
                    }
                    {edit && <button onClick={() => setEdit(false)} type="button" className="rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                        close
                    </button>}
                    
                   {enableAddUrlAndEnvBtn && name === 'defaultEnv'  && <>
                   {!spinnerBtn ? <>
                    <button onClick={saveDefaultUrlAndEnv} type="button" className="rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                        Save default URL and Env
                    </button> 
                    </> : <SpinnerBtn style={"rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"}/>}
                   </>}
                   
                   </div>
                </dd>
            </div>
        </>
    )
}
